<script>
export default {
    name: 'NavigationHeader',
    props: {
        route: {
            type: String,
            required: true,
        },
        navigationText: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
};
</script>

<template>
<div class="navigation-header">
    <router-link class="router-link" :to="route">
        <img src="@/assets/starface_icons_png/24/orange/back_24.png" alt="Pfeil zur Übersicht">
        <span class="back-to">{{navigationText}}</span>
    </router-link>
    <div class="title">
        {{title}}
    </div>
</div>
</template>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
.navigation-header {
    .router-link {
        display: flex;
        align-items: center;
        img {
            height: 24px;
            width: 24px;
            margin-right: 8px;
        }
        .back-to {
            color: $orange;
            font-size: 18px;
            text-align: right;
        }
    }
    .title {
        padding: 24px 0;
        font-size: 32px;
        color: $grey-dark;
    }
}
</style>
